import { FetchedUserCities } from '@flyblack/common/domains';

import { authorizedApi } from '../network/authorized-api';

export const getUserCities = () => authorizedApi.get<FetchedUserCities>(`/v1/user-cities`);

export const updateUserCities = (placeId: string, relevantLocationIds: number[]) =>
  authorizedApi.put(`/v1/user-cities`, { placeId, ids: relevantLocationIds });
